<template>
  <v-card
    elevation="2"
    outlined
  >
    <v-toolbar
      class="primaryLight white--text"
      dense
    >
      <div>NUM. DE MEDIOS ACTUANTES EN EL INCENDIO</div>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col
          cols="6"
        >
          <v-row
            v-for="(medio, i) in datos.lista1"
            :key="i"
            class="align-center mb-1"
          >
            <v-col
              cols="10"
              class="py-1 caption"
            >
              {{ medio.nombre }}
            </v-col>
            <v-col
              cols="2"
              class="py-1"
            >
              <v-text-field
                v-model.number="medio.value"
                type="number"
                min="0"
                hide-details
                dense
              />
            </v-col>
          </v-row>
        </v-col>

        <v-col
          cols="6"
        >
          <v-row
            v-for="(medio, i) in datos.lista2"
            :key="i"
            class="align-center mb-1"
          >
            <v-col
              cols="10"
              class="py-1 caption"
            >
              {{ medio.nombre }}
            </v-col>
            <v-col
              cols="2"
              class="py-1"
            >
              <v-text-field
                v-model.number="medio.value"
                type="number"
                min="0"
                hide-details
                dense
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    value: { type: Object, required: true }
  },
  computed: {
    datos: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  }
}
</script>
